import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createCartItemApi } from '@!/Api/cart'
import { cartItemsKeys } from '@!/Api/queryKeys'
import { isBlank } from '@!/Util'

export const useCreateCartItem = (userHash, detail) => {
  const [apiError, setApiError] = useState(null)

  const queryClient = useQueryClient()
  const createCartItemMutation = useMutation({
    mutationFn: () => createCartItemApi({ content_id: detail.content_id }),
    onMutate: async () => {
      const previousData = queryClient.getQueryData(cartItemsKeys.cartItemsLoggedIn(userHash))
      queryClient.setQueryData(cartItemsKeys.cartItemsLoggedIn(userHash), (old) => {
        const filtered = isBlank(old) ? old : old.filter((o) => o.content_id === detail.content_id)
        return [{ ...detail }, filtered]
      })
      return { previousData }
    },
    onError: (error, variables, context) => {
      queryClient.setQueryData(cartItemsKeys.cartItemsLoggedIn(userHash), context.previousData)
      if (error.data?.error) {
        setApiError(error.data.error)
      } else {
        setApiError('server error')
      }
    },
    onSettled: () => {
      // API実行終了時はreact-queryのキャッシュをクリアする
      queryClient.invalidateQueries({ queryKey: cartItemsKeys.cartItemsLoggedIn(userHash) })
    },
  })

  return [createCartItemMutation, apiError]
}
